import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment } from "react";
import { toast } from "react-toastify";
import { DeleteCustomer } from "../API/CustomerAPI";
import { useNavigate } from "react-router-dom";

const DeleteCustomerModel = ({
  deleteCust,
  setDeleteCust,
  id,
  setFirst,
  setGetCust,
  getCust
}) => {
  const navigate = useNavigate()

  const handleDeleteCustomer = async () => {
    id.map(async (cust) => {
      const params = {
        customer_id: cust.customer_id,
      };

      const result = await DeleteCustomer(params);
      if (result) {
        setFirst([]);
        setDeleteCust(false);
        setGetCust(!getCust);
        toast.error("Customer deleted successfully", { autoClose: 5000 });
        navigate('/customers')
      } else {
        toast.error("Something went wrong", { autoClose: 5000 });
      }
    });
  };

  return (
    <div>
      <Transition.Root show={deleteCust} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setDeleteCust}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-[#c1c9d2b3]" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white py-[16px] px-[20px] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[380px]">
                  <div className="text-[#414552]">
                    <div className="font-semibold text-base">
                      Delete {id && id.length} customer?
                    </div>
                    <p className="text-[14px] mt-1">
                      This will permanently remove the customer’s billing
                      information and immediately cancel any current
                      subscriptions. Past payments or invoices associated with
                      the customer will still remain. This action cannot be
                      undone.
                    </p>
                  </div>
                  <div className="flex justify-end gap-2 mt-2">
                    <button
                      className="input_focus_shadow h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px] flex items-center gap-2"
                      onClick={() => setDeleteCust(false)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleDeleteCustomer}
                      className="h-[30px] rounded-[8px] bg-[#df1b41] text-[14px] font-semibold p-[0_8px] flex items-center gap-2 text-white leading-[30px]"
                    >
                      Delete
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default DeleteCustomerModel;
